var _rect, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriquette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#2E2F39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.009 64.7852H44.3198L44.3198 133.637C44.1084 134.466 44 135.307 44 136.16C44 149.122 69.074 159.63 100.004 159.63C130.882 159.63 155.924 149.158 156.009 136.226H156.009V136.177C156.009 136.171 156.009 136.166 156.009 136.16C156.009 136.154 156.009 136.148 156.009 136.142L156.009 64.7852Z",
    fill: "#0C0C0C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.004,
    cy: 63.1,
    rx: 56.0044,
    ry: 23.4701,
    fill: "#4A4545"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.3414,
    cy: 59.9982,
    rx: 6.80328,
    ry: 5.13197,
    fill: "#2D2D31"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.5543,
    cy: 59.9977,
    rx: 6.80327,
    ry: 5.13197,
    fill: "#2D2D31"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.767,
    cy: 59.9987,
    rx: 6.80328,
    ry: 5.13197,
    fill: "#2D2D31"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.9478,
    cy: 73.6823,
    rx: 6.80327,
    ry: 5.13197,
    fill: "#2D2D31"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.162,
    cy: 73.6823,
    rx: 6.80328,
    ry: 5.13197,
    fill: "#2D2D31"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.272,
    cy: 105.077,
    r: 5.27197,
    fill: "#7FC8C8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.321,
    cy: 105.077,
    r: 5.27197,
    fill: "#7FC8C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriquette);
export default __webpack_public_path__ + "static/media/briquette.8d3316f48bfbf631ac8a363528cf45ca.svg";
export { ForwardRef as ReactComponent };